/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { SVGIcon } from "@nordcloud/gnui";
import { Provider } from "~/generated/graphql";
import { getProviderIconName } from "~/tools";

type Props = {
  provider: Provider;
};

export function ProviderCell({ provider }: Props) {
  return <SVGIcon name={getProviderIconName(provider)} size="md" />;
}
